import React from 'react';
import Modal from 'antd/lib/modal';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { ChildBoard } from '../../../types';

export interface NewBoardFormProps {
  visible: boolean;
  newBoard?: ChildBoard;
  onCreate: (name: string) => void;
  onClose: () => void;
  boards: ChildBoard[] | [] | undefined;
}

const NewBoardForm: React.FC<NewBoardFormProps> = ({ visible, newBoard, onCreate, onClose, boards = [] }) => {
  const checkNameValidity = (name: string) => {
    if (!name) {
      return 'Name is required.';
    }
    const restrictedNameList = boards.map((board) => board.name.toLowerCase());
    if (restrictedNameList.includes(name.toLocaleLowerCase())) {
      return 'This Inbox already has a Board with that name.';
    }
    return;
  };
  const handleSubmit = (value: any) => onCreate(value.boardName);
  return (
    <Modal title="New Board" destroyOnClose footer={null} open={visible} onCancel={onClose}>
      <div className="form-container padding-hsides-md">
        <Formik initialValues={{ boardName: newBoard?.name || '' }} onSubmit={handleSubmit}>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="boardName">Board Name</label>
                <div className="input-group">
                  <Field name="boardName" id="boardName" className="form-control" autoFocus validate={checkNameValidity} />
                </div>
                <ErrorMessage name="boardName">
                  {(msg: string) => <div className="invalid-feedback">{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="flex-container justify-end padding-bottom-sm">
                <button type="button" className="btn margin-right-sm" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Create
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default NewBoardForm;
